import { Image, Result, Typography } from 'antd';

import icon from '../../../assets/images/icon.svg';

export const OnboardHeader = () => {
  return (
    <>
      <Result
        icon={<Image width={50} src={icon} preview={false} />}
        title={
          <Typography.Title level={3} style={{ fontWeight: 'bold' }}>
            Welcome to EnzRossi Connect!
          </Typography.Title>
        }
      />
    </>
  );
};
